import IconShieldCheck from '~/domains/design-system/icons/IconShieldCheck';
import { Text } from '~/domains/design-system/Text';
import { Avatar } from '~/domains/design-system/Avatar';
import dt from '~/testing';

import type { PromoTicketBonus } from '../../types/promoCodes.types';

import { useStyles } from './PromoTicketCard.styles';

export function PromoTicketCard({
  amount,
  title1,
  title2,
  description1,
  description2,
  associatedUser,
}: PromoTicketBonus) {
  const { classes, theme } = useStyles();

  return (
    <div className={classes.container} data-test-id={dt.promotions.promoTicketCard}>
      <div className={classes.contentCard}>
        <div className={classes.bonusAmountRow}>
          <div className={classes.bonusAmount}>{amount}</div>
          <div className={classes.bonusLabel}>
            <Text variant="subhead-x-large" className={classes.bonusLabelText}>
              {title1}
            </Text>
            <Text variant="subhead-x-large" className={classes.bonusLabelText}>
              {title2}
            </Text>
          </div>
        </div>

        <Text variant="subhead-x-small" className={classes.description}>
          {description1}
          {description2 && (
            <>
              <br />
              {description2}
            </>
          )}
        </Text>

        {associatedUser && (
          <div className={classes.associatedUser}>
            <Avatar size={24} src={associatedUser.avatarUrl} alt={associatedUser.name} />
            <Text variant="subhead-x-small">by {associatedUser.name}</Text>
            {associatedUser.isVerified && (
              <IconShieldCheck size={16} color={theme.colors.blue[6]} />
            )}
          </div>
        )}
      </div>

      <svg width="0" height="0" aria-hidden="true">
        <filter id="titleShadow">
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.75" />
          <feComposite operator="out" in="SourceAlpha" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend in2="SourceGraphic" />
        </filter>
      </svg>
    </div>
  );
}
